import type { StoreDetails } from '@api/userAndStoreContext'

/**
 * Filters stores based on search query.
 *
 * Performs case-insensitive prefix matching on storeName.
 * Returns all stores when query is empty.
 * Assumes stores are pre-sorted; order is preserved.
 */
export function filterStores (stores: StoreDetails[], query: string): StoreDetails[] {
    if (query.trim() === '') {
        return stores
    }

    const lowerQuery = query.trim().toLowerCase()

    return stores.filter((store) =>
        (store.storeName || '').toLowerCase().startsWith(lowerQuery),
    )
}
